/**
 * Conversation namespace for chatbot detail pages (Styling, Setup, etc.).
 * Keeps sidebar preview state separate from the main dashboard Preview page (`in-app`).
 */
export const CHATBOT_DETAILS_TEST_PREVIEW_NAMESPACE = 'chatbot-details-test-preview';

/**
 * Appends a short demo exchange after the chatbot's configured initial messages
 * so the sidebar always shows a concrete example thread.
 */
export function mergeTestPreviewInitialMessages(baseInitialMessages = []) {
  const now = Date.now();
  return [
    ...baseInitialMessages,
    {
      role: 'user',
      content: 'Can you help me customize my agent?',
      status: 'complete',
    },
    {
      role: 'assistant',
      content:
        'Of course! I can help you customize your agent. You can change the colors, add your logo, customize messages, and much more. What would you like to customize first?',
      status: 'complete',
      date_created: now,
    },
  ];
}
